import { useEffect, useState } from "react";
import { getInvoices } from "../api/invoiceapi"; 
import {
  FaFileInvoice,
  FaClock,
  FaWallet,
  FaPercentage,
  FaRupeeSign ,
  FaCalendarDay,
 FaUsers,
 FaChartBar
  
} from "react-icons/fa";


function Dashboard({ setPage }) {

  const [invoices, setInvoices] = useState([]);

useEffect(() => {
  loadData();
}, []);

const loadData = async () => {
  try {
    const res = await getInvoices();
    setInvoices(res.data);

    console.log(res.data);
  } catch (error) {
    console.log(error);
  }
};
const totalGST = invoices.reduce(
  (sum, item) => sum + item.gst,
  0
);
const totalSales = invoices.reduce(
  (sum, item) => sum + item.grandTotal,
  0
);
const pendingAmount = invoices.reduce(
  (sum, item) =>
    sum + (item.grandTotal - item.receivedAmount),
  0
);
const totalReceived = invoices.reduce(
  (sum, item) => sum + (item.receivedAmount || 0),
  0
);
  return (
    <div className="dashboard-layout">

    

      {/* Main */}
      <main className="dashboard-main">

        <h4>Manage invoices, sales, and GST records efficiently.</h4>

        {/* Cards */}
       <div className="cards">


  <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Total Invoices</p>
        <h5>{totalSales}</h5>
      </div>

      <div className="icon-box">
       <FaFileInvoice />
      </div>

    </div>
  </div>

  <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Pending Amount</p>
        <h5>₹{pendingAmount}</h5>
      </div>

      <div className="icon-box">
       <FaClock />
      </div>

    </div>
  </div>
 <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Received Amount</p>
        <h5>₹{totalReceived}</h5>
      </div>

      <div className="icon-box">
       <FaWallet />
      </div>

    </div>
  </div>

  <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>GST Collected</p>
        <h5>₹{totalGST}</h5>
      </div>

      <div className="icon-box">
         <FaPercentage />
      </div>

    </div>
  </div>
 <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Total Sales</p>
        <h5>₹20,000</h5>
      </div>

      <div className="icon-box">
         <FaRupeeSign  />
      </div>

    </div>
  </div>
   <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Today Revenue</p>
        <h5>₹30,000</h5>
      </div>

      <div className="icon-box">
         <FaCalendarDay/>
      </div>

    </div>
  </div>
     <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Active Clients</p>
        <h5>30</h5>
      </div>

      <div className="icon-box">
         <FaUsers/>
      </div>

    </div>
  </div>
  <div className="card dashboard-card">
    <div className="card-header">

      <div>
        <p>Monthly Profit Report</p>
        <h5>₹10,000</h5>
      </div>

      <div className="icon-box">
         <FaChartBar />
      </div>

    </div>
  </div>
</div>
        {/* Recent Invoices Card */}
       <div className="recent-card">

  <div className="recent-header">
    <h2>Recent Invoices</h2>
  </div>

  <div className="recent-table">

    <div className="table-head">
      <span>Customer</span>
      <span>Amount</span>
      <span>Status</span>
    </div>

    {invoices.map((invoice) => (

      <div className="invoice-row" key={invoice.id}>

        <span>{invoice.customer}</span>

        <span>₹{invoice.grandTotal}</span>

        <span
          className={
            invoice.receivedAmount >= invoice.grandTotal
              ? "status paid"
              : "status pending"
          }
        >
          {
            invoice.receivedAmount >= invoice.grandTotal
              ? "Paid"
              : "Pending"
          }
        </span>

      </div>

    ))}

  </div>

</div>

      </main>

    </div>
  );
}

export default Dashboard;